import type { Product } from '../types';
import { ProductsMobileSlider } from './ProductsMobileSlider';
import { TextInfoBlock } from './TextInfoBlock';
import { TextTitleBlock } from './TextTitleBlock';
import type { textDataType } from './type';

type MobileProductGridProps = {
  fetchedProducts: Product[];
  textData: textDataType;
  setIsOpen: () => void;
};

export const MobileProductsGrid = ({
  fetchedProducts,
  textData,
  setIsOpen,
}: MobileProductGridProps) => {
  return (
    <>
      <TextTitleBlock textData={textData} />
      <ProductsMobileSlider fetchedProducts={fetchedProducts} />
      <TextInfoBlock setIsOpen={setIsOpen} textData={textData.infoBlock} />
    </>
  );
};
